"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helperCall = exports.S3FileUploadControl = exports.UploadFileDialog = void 0;

var _ClientAPI = babelHelpers.interopRequireDefault(require("platform/ClientAPI"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _messageChannel = require("message-channel");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _jQuery = babelHelpers.interopRequireDefault(require("jQuery"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp, _class3, _descriptor7, _temp2, _class5, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _class6, _temp3;

function safePath(text) {
  return text.replace(/[^a-zA-Z0-9\.-]/g, '_').replace(/^_*/, '').replace(/_*$/, '');
}

var UploadFileBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(UploadFileBody, _Component);

  function UploadFileBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, UploadFileBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(UploadFileBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "sizeIsUnknown", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "size", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "remaining", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "speed", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "percent", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "indeterminate", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(UploadFileBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "upload-body"
      }, _react.default.createElement("div", {
        className: "assignment-icon"
      }), _react.default.createElement("div", {
        className: "upload-determinate"
      }, _react.default.createElement("div", {
        className: "progress progress-striped active"
      }, _react.default.createElement("div", {
        className: "progress-bar progress-bar-success",
        style: {
          width: this.percent + '%'
        }
      }))), _react.default.createElement("h4", null, "Uploading"), _react.default.createElement("p", null, "Do not close this window until the upload is complete."));
    }
  }, {
    key: "formatSize",
    value: function formatSize(size) {
      var suffix = 'B';

      if (size > 900) {
        suffix = 'kB';
        size /= 1024;
      }

      if (size > 900) {
        suffix = 'MB';
        size /= 1024;
      }

      if (size > 900) {
        suffix = 'GB';
        size /= 1024;
      }

      if (suffix == 'B' || Math.round(size) === size) return size + suffix;
      return size.toFixed(2) + suffix;
    }
  }]);
  return UploadFileBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "sizeIsUnknown", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "size", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "remaining", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Unknown';
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "speed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Unknown';
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "percent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "indeterminate", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
var UploadFileDialog = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(UploadFileDialog, _Modal);

  function UploadFileDialog() {
    var _this2;

    babelHelpers.classCallCheck(this, UploadFileDialog);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(UploadFileDialog).call(this, 'file-upload-dialog'));
    _this2.removeOnHide = true;
    _this2.classList = _this2.classList.concat('upload-dialog');
    babelHelpers.initializerDefineProperty(_this2, "modalContent", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.uploadState = {};

    _this2.setUploadState({});

    _this2.setTitle('Uploading video');

    return _this2;
  }

  babelHelpers.createClass(UploadFileDialog, [{
    key: "setTitle",
    value: function setTitle(value) {
      this._title = value;
      this.updateTitle();
    }
  }, {
    key: "setUploadState",
    value: function setUploadState(data) {
      console.log("UploadFileDialog::setUploadState(): ", data);
      this.uploadState = Object.assign({}, this.uploadState, data);

      if (this.element) {
        _reactDom.default.render(_react.default.createElement(UploadFileBody, this.uploadState), this.element.querySelector('#file-upload-dialog-content'));
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this3 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(UploadFileDialog.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (node) {
        _reactDom.default.render(_react.default.createElement(UploadFileBody, _this3.uploadState), node.querySelector('#file-upload-dialog-content'));

        return node;
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.element) {
        _reactDom.default.unmountComponentAtNode(this.element.querySelector('#file-upload-dialog-content'));
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(UploadFileDialog.prototype), "hide", this).call(this);
    }
  }, {
    key: "title",
    get: function get() {
      return this._title;
    }
  }]);
  return UploadFileDialog;
}(_base.default), _temp2), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "modalContent", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "<div id='file-upload-dialog-content'></div>";
  }
})), _class3);
exports.UploadFileDialog = UploadFileDialog;
var S3FileUploadControl = (_class5 = (_temp3 = _class6 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(S3FileUploadControl, _Component2);
  babelHelpers.createClass(S3FileUploadControl, [{
    key: "gotField",
    value: function gotField(field) {}
  }, {
    key: "gotFrame",
    value: function gotFrame(frame) {
      this.uploadFrame = frame;
    }
  }]);

  function S3FileUploadControl(props) {
    var _this4;

    babelHelpers.classCallCheck(this, S3FileUploadControl);
    _this4 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(S3FileUploadControl).call(this, props));
    _this4.state = {
      bucket: null,
      region: null,
      prefix: null,
      frameContent: null,
      currentValue: null,
      loaded: false
    };
    babelHelpers.initializerDefineProperty(_this4, "setUploadCallback", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "initialValue", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "buttonContent", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "buttonClass", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "selectedButtonClass", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    if (_this4.initialValue) _this4.state.currentValue = _this4.initialValue;
    _this4.messageChannel = new _messageChannel.Channel();
    return _this4;
  }

  babelHelpers.createClass(S3FileUploadControl, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "videoSubmit"
      }, _react.default.createElement("div", {
        className: "s3-file-uploader"
      }, _react.default.createElement("div", {
        className: _classList.default.join('s3FileUploader', 'light-bg', !this.state.loaded && 'spinning'),
        id: "s3FileUploadField",
        "data-upload-title": "Uploading video",
        "data-spin": "true",
        ref: this.gotField
      }, _react.default.createElement("iframe", {
        ref: this.gotFrame,
        scrolling: "no",
        width: 1,
        height: 1,
        className: "fileUploadControl",
        style: {
          border: 0,
          padding: 0,
          margin: 0,
          width: this.state.iframeSize ? this.state.iframeSize.width : "1px",
          height: this.state.iframeSize ? this.state.iframeSize.height : "1px"
        },
        frameBorder: 0,
        allowTransparency: true,
        src: this.state.frameContent ? "".concat(this.state.frameContent.path, "#sharedKey=").concat(this.messageChannel.name) : 'about:blank'
      }), _react.default.createElement("input", {
        type: "hidden",
        name: "formData[value/8]",
        value: ""
      }))), _react.default.createElement("div", {
        id: "fileUploadListener",
        style: {
          display: 'none'
        }
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getBucket();
      this.getUploader();
      this.setupMessageChannel();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.messageChannel.destroy();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.frameContent && this.state.frameContent) {
        this.messageChannel.init(this.uploadFrame.contentWindow, this.state.frameContent.origin);
      }

      if (prevState.iframeSize !== this.state.iframeSize) {
        (0, _jQuery.default)(window).triggerHandler('resize');
      }

      if (prevProps.generation != this.props.generation) {
        this.messageChannel.call('ResetUpload');
      }
    }
  }, {
    key: "_requestJSON",
    value: function _requestJSON(method, path, data) {
      if (method == 'GET') {
        if (S3FileUploadControl._cache[path]) return S3FileUploadControl._cache[path];
      }

      var P = new _promisePolyfill.default(function (resolve) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, path, true);
        if (data !== void 0) xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            resolve(JSON.parse(xhr.responseText));
          }
        };

        xhr.send(data === void 0 ? null : JSON.stringify(data));
      });
      if (method == 'GET') S3FileUploadControl._cache[path] = P;else S3FileUploadControl._cache = {};
      return P;
    }
  }, {
    key: "_getJSON",
    value: function _getJSON(path) {
      return this._requestJSON('GET', path);
    }
  }, {
    key: "_postJSON",
    value: function _postJSON(path, data) {
      return this._requestJSON('POST', path, data);
    }
  }, {
    key: "getBucket",
    value: function getBucket() {
      var _this5 = this;

      this._getJSON('data/upload/bucket').then(function (_ref) {
        var bucket = _ref.bucket,
            region = _ref.region,
            prefix = _ref.prefix;
        return _this5.setState({
          bucket: bucket,
          region: region,
          prefix: prefix
        });
      });
    }
  }, {
    key: "getUploader",
    value: function getUploader() {
      var _this6 = this;

      this._getJSON("data/upload/html5?bodyClass=".concat(encodeURIComponent(document.body.className))).then(function (value) {
        var p = /Expires=(\d+)/.exec(value.path);

        if (p && Date.now() > 1000 * (Number(p[1]) - 60)) {
          delete S3FileUploadControl._cache["data/upload/html5?bodyClass=".concat(encodeURIComponent(document.body.className))];

          _this6.getUploader();

          return;
        }

        _this6.setState({
          frameContent: value
        });
      });
    }
  }, {
    key: "rejectInvalidType",
    value: function rejectInvalidType(file) {
      this.messageChannel.call('ResetUpload');
      setTimeout(function () {
        alert("The file ".concat(file.name, " is not of the correct type. Please select another file."));
      }, 0);
      return;
    }
  }, {
    key: "rejectTooLarge",
    value: function rejectTooLarge(file) {
      this.messageChannel.call('ResetUpload');
      setTimeout(function () {
        alert("The file ".concat(file.name, " too large. Please select another file."));
      }, 0);
      return;
    }
  }, {
    key: "fileListChangedSuccess",
    value: function fileListChangedSuccess(object) {
      var _this7 = this;

      setTimeout(function () {
        _this7.messageChannel.methods.DispatchEvent('FileListChangedSuccess', object);
      }, 0);
    }
  }, {
    key: "doUpload",
    value: function doUpload() {
      var _this8 = this;

      if (this.uploadPromise) return this.uploadPromise;
      return this.uploadPromise = new _promisePolyfill.default(function (resolve) {
        var D = new UploadFileDialog();
        D.show().then(function () {
          _this8.fileUploadDialog = D;
          var object = _this8.uploadData;

          _this8._postJSON('data/upload/newFolder', {
            newFolder: true
          }).then(function (value) {
            var totalFileSize = 0,
                cv = {},
                sizeIsUnknown = false;
            object.files = object.files.slice(0, 1);
            object.files.forEach(function (file) {
              cv[file.id] = 0;
              totalFileSize += file.size;
              if (file.unknownSize) sizeIsUnknown = true;
            });
            D.setUploadState({
              sizeIsUnknown: sizeIsUnknown,
              size: totalFileSize,
              remaining: 'Unknown',
              speed: 'Unknown',
              percent: 0,
              replacementNames: {},
              folder: value,
              current: cv,
              completed: 0,
              files: object.files,
              count: object.files.length,
              total: totalFileSize,
              start: Date.now(),
              finishedUpload: resolve
            });

            _this8.messageChannel.call('StartFileUpload', value);
          });
        });
      });
    }
  }, {
    key: "fileListChanged",
    value: function fileListChanged(object) {
      if (!object.files.length) {
        this.fileListChangedSuccess(object);
        this.setUploadCallback(null);
        return;
      }

      var file = object.files[0];
      this.uploadData = object;

      if (this.props.accept) {
        if (file.type == 'application/octet-stream' || !file.type || !this.props.accept.types) {
          if (this.props.accept.extensions) {
            var ext = file.name.split('.').pop().toLowerCase();

            if (this.props.accept.extensions.indexOf(ext) == -1) {
              this.rejectInvalidType(file);
              return;
            }
          }

          if (this.props.accept.notExtensions) {
            var ext = file.name.split('.').pop().toLowerCase();

            if (this.props.accept.notExtensions.indexOf(ext) != -1) {
              this.rejectInvalidType(file);
              return;
            }
          }
        } else {
          if (this.props.accept.types) {
            var isGood = false;
            this.props.accept.types.forEach(function (type) {
              var qq = type.split('/');

              if (qq[0] == '*') {
                isGood = true;
                return;
              }

              if (qq[1] == '*') {
                if (file.type.split('/').shift().toLowerCase() == qq[0].toLowerCase()) {
                  isGood = true;
                  return;
                }
              }

              if (type.toLowerCase() == file.type.split(';').shift().toLowerCase()) {
                isGood = true;
                return;
              }
            });

            if (!isGood) {
              this.rejectInvalidType(file);
              return;
            }
          }
        }
      }

      if (this.props.maxFileSize && this.props.maxFileSize != -1) {
        var mfs = this.props.maxFileSize;

        if (file.size && file.size > mfs) {
          this.rejectTooLarge(file);
          return;
        }
      }

      this.fileListChangedSuccess(object);
      this.setUploadCallback(this.doUpload);
    }
  }, {
    key: "fileUploadBegin",
    value: function fileUploadBegin(object) {
      var _this9 = this;

      var name = safePath(object.fileName);

      this._postJSON('data/upload/uploadData', {
        folder: object.group,
        name: name,
        type: object.fileType
      }).then(function (result) {
        _this9.messageChannel.call('UploadFile', object.id, result);
      });
    }
  }, {
    key: "fileUploadProgress",
    value: function fileUploadProgress(object) {
      if (object.indeterminate) {
        this.fileUploadDialog.setUploadState({
          indeterminate: true
        });
        return;
      }

      var T = {
        indeterminate: false
      };
      var CS = this.fileUploadDialog.uploadState;
      var current = CS.current,
          total = CS.total,
          start = CS.start;
      current = Object.assign({}, current);
      current[object.id] = object.current;
      T.current = current;
      var currentValue = 0;
      Object.keys(current).forEach(function (i) {
        return currentValue += current[i];
      });
      var time = Date.now() - start;
      var ts = time / 1000;
      var spd = currentValue / ts;
      var rem = total - currentValue;
      var rs = rem / spd;
      rs = Math.round(rs);
      var sec = rs % 60;
      var min = rs / 60;
      min = Math.floor(min);
      sec = String(sec);
      if (sec.length < 2) sec = '0' + sec;
      T.remaining = "".concat(min, ":").concat(sec);
      T.percent = 100 * (currentValue / total);
      this.fileUploadDialog.setUploadState(T);
    }
  }, {
    key: "fileUploadComplete",
    value: function fileUploadComplete(object) {
      var files = this.fileUploadDialog.uploadState.files;
      var file = files.filter(function (v) {
        return v.id == object.id;
      }).shift();
      var name = file.name;
      var mode = 'Uploaded';
      var pathToFile = this.fileUploadDialog.uploadState.folder + safePath(name);
      var cc = this.fileUploadDialog.uploadState.completed + 1;
      var T = {
        completed: cc
      };
      this.fileUploadDialog.setUploadState(T);

      if (cc == this.fileUploadDialog.uploadState.count) {
        this.fileUploadDialog.hide();
        this.messageChannel.call('CompletedUpload');
      }

      var P = "https://s3".concat(this.state.region == 'us-east-1' ? '' : "-".concat(this.state.region), ".amazonaws.com/").concat(this.state.bucket, "/").concat(this.state.prefix).concat(pathToFile);
      this.fileUploadDialog.uploadState.finishedUpload(P);
      this.setState({
        currentValue: P
      });
    }
  }, {
    key: "fileUploadSetIframeSize",
    value: function fileUploadSetIframeSize(object) {
      this.setState({
        iframeSize: {
          width: object.width,
          height: object.height
        }
      });
      return true;
    }
  }, {
    key: "fileUploadLoaded",
    value: function fileUploadLoaded() {
      this.setState({
        loaded: true
      });
      var RS = {};
      var PN = ['--scalable-base-ratio', '--scalable-target-ratio', '--scalable-target-cell-height', '--scalable-target-cell-width', '--scalable-target-cell-columns', '--scalable-target-cell-rows', '--scalable-target-font-ratio', '--scalable-target-font-size', '--scalable-unit', '--scalable-mobile'];
      PN.forEach(function (v) {
        return RS[v] = window.getComputedStyle(document.body).getPropertyValue(v);
      });
      var X = document.createElement('div');
      document.body.appendChild(X);
      X.style.width = RS['--scalable-unit'];
      RS['--scalable-unit'] = X.offsetWidth + 'px';
      document.body.removeChild(X);
      this.messageChannel.call('SetRootStyles', RS);

      if (this.state.currentValue) {
        this.messageChannel.call('SetSelectedFilename', this.state.currentValue.split('/').pop());
      }
    }
  }, {
    key: "fileUploadRemoveUploadedFile",
    value: function fileUploadRemoveUploadedFile() {
      this.setState({
        currentValue: null
      });
    }
  }, {
    key: "unbindResize",
    value: function unbindResize() {
      (0, _jQuery.default)(window).off('resize.fileUploader');
      return true;
    }
  }, {
    key: "bindResize",
    value: function bindResize(name) {
      var _this10 = this;

      (0, _jQuery.default)(window).on('resize.fileUploader', function () {
        _this10.messageChannel.call(name);
      });
      return true;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return (0, _jQuery.default)(this.fileUploadControl).width();
    }
  }, {
    key: "getButtonInfo",
    value: function getButtonInfo() {
      return {
        buttonContent: this.buttonContent,
        buttonClass: this.buttonClass,
        selectedButtonClass: this.selectedButtonClass
      };
    }
  }, {
    key: "setupMessageChannel",
    value: function setupMessageChannel() {
      this.messageChannel.addEventListener('FileListChanged', this.fileListChanged);
      this.messageChannel.addEventListener('FileUploadBegin', this.fileUploadBegin);
      this.messageChannel.addEventListener('FileUploadProgress', this.fileUploadProgress);
      this.messageChannel.addEventListener('FileUploadComplete', this.fileUploadComplete);
      this.messageChannel.methods.SetIframeSize = this.fileUploadSetIframeSize;
      this.messageChannel.addEventListener('Loaded', this.fileUploadLoaded);
      this.messageChannel.methods.RemoveAlreadyUploadedFile = this.fileUploadRemoveUploadedFile;
      this.messageChannel.methods.UnbindResize = this.unbindResize;
      this.messageChannel.methods.BindResize = this.bindResize;
      this.messageChannel.methods.GetWidth = this.getWidth;
      this.messageChannel.methods.GetButtonInfo = this.getButtonInfo; // Tagging

      this.messageChannel.addEventListener('FileListChangedSuccess', this.sendConversionTag);
    }
  }, {
    key: "sendConversionTag",
    value: function sendConversionTag() {}
  }]);
  return S3FileUploadControl;
}(_react.Component), _class6._cache = {}, _temp3), (babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotField"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotFrame", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotFrame"), _class5.prototype), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "setUploadCallback", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "initialValue", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "doUpload", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "doUpload"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileListChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileListChanged"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileUploadBegin", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileUploadBegin"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileUploadProgress", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileUploadProgress"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileUploadComplete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileUploadComplete"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileUploadSetIframeSize", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileUploadSetIframeSize"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileUploadLoaded", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileUploadLoaded"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fileUploadRemoveUploadedFile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fileUploadRemoveUploadedFile"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "unbindResize", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "unbindResize"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "bindResize", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "bindResize"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "getWidth", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "getWidth"), _class5.prototype), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "buttonContent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Upload';
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "buttonClass", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'btn btn-primary upload-btn';
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "selectedButtonClass", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'btn btn-default btn-block btn-lg text-left btn-video-selected';
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "getButtonInfo", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "getButtonInfo"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "sendConversionTag", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "sendConversionTag"), _class5.prototype)), _class5);
exports.S3FileUploadControl = S3FileUploadControl;
var helperCall = S3FileUploadControl.helperCall;
exports.helperCall = helperCall;